// @ts-nocheck 89c85857
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_Vline'],
      sections: [
        addPanel.sections.getSections().vectorShape.verticalLinesSection,
      ],
    };
  },
};
